import FeaturedOfferCard from 'features/rewards/components/FeaturedOfferCard/FeaturedOfferCard';
import React from 'react';
import { FlatList, ImageSourcePropType, StyleSheet, View } from 'react-native';
import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

interface FeaturedOfferCard extends PressableAnalyticsProps {
  id: string;
  titleText: string;
  logoImage?: ImageSourcePropType;
  backgroundImage?: ImageSourcePropType;
  activateButtonLabel: string;
  onPress: () => void;
}

export interface featuredOfferCardCarouselProps {
  offers: FeaturedOfferCard[];
}
const FeaturedCardCarousel = ({ offers }: featuredOfferCardCarouselProps) => {
  return (
    <FlatList
      contentContainerStyle={styles.featuredCardCarousel}
      data={offers}
      renderItem={({ item }) => (
        <FeaturedOfferCard
          id={item.id}
          titleText={item.titleText}
          logoImage={item.logoImage}
          backgroundImage={item.backgroundImage}
          activateButtonLabel={item.activateButtonLabel}
          onPress={item.onPress}
          analyticsId={item.analyticsId}
          customAttributes={item.customAttributes}
        />
      )}
      keyExtractor={(item) => item.id.toString()}
      horizontal
      showsHorizontalScrollIndicator={false}
      ItemSeparatorComponent={() => <View style={styles.separator} />}
      removeClippedSubviews={false}
    />
  );
};

const styles = StyleSheet.create({
  featuredCardCarousel: {
    paddingEnd: theme.spacing.m,
    paddingStart: theme.spacing.m,
    paddingVertical: theme.spacing.m,
  },
  separator: {
    backgroundColor: 'transparent',
    width: theme.spacing.s,
  },
});

export default FeaturedCardCarousel;
